import React from 'react';

import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';

export default function Footer(props) {
  return (
    <Box
      sx={{
        fontWeight: 'light',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        padding: 1,
        alignItems: 'center',
      }}
    >
      <Typography variant="caption" sx={{ pr: 1, color: 'text.secondary' }}>{` Powered by `}</Typography>
      <Link color="inherit" href="#">
        <img src="/images/nile-logo-v2.png" alt="Nile Global Inc." width="30" />
      </Link>
    </Box>
  );
}
